export default __webpack_public_path__ + "static/media/vol5_2.0df6abab.png";